<template>
  <div class="bottom_tree_table">
    <div class="bottom_left">
      <div class="left_tree">
        <el-tree ref="depTree" :data="frameTree" :accordion="true" :props="defaultProps"
          :default-expanded-keys="defaultExpandedKeys" class="tree_1" highlight-current node-key="sortID"
          @current-change="currentOrgChangeHandler">
          <template #default="{ data }">
            <span style="font-size:14px">
              {{ data.sortName }}[{{ data.sortCode }}]
            </span>
          </template>
        </el-tree>
      </div>
    </div>
    <div class="bottom_right">
      <div class="right_button"></div>
      <div><img :src="imageUrl" alt="" @click="download" /></div>
    </div>
  </div>
</template>
<script>
import stamp from "@/CommonDP/service/eSeal-service";
import tzService from "@/CommonDP/service/tz-service";
import { getEnterpriseId } from "@/CommonDP/utils/auth";
export default {
  data() {
    return {
      defaultProps: {
        children: "treeList",
        label: "sortName"
      },
      frameTree: [], // 树
      defaultExpandedKeys: [],
      sortID: undefined,
      pID: undefined,
      imageUrl: ""
    };
  },
  computed: {
    enterpriseId() {
      return getEnterpriseId("enterpriseId");
    }
  },
  watch: {
    imageUrl(newValue, oldValue) {
      if (oldValue) {
        URL.revokeObjectURL(oldValue);
      }
    }
  },
  created() {
    this.getFrameTree();
  },
  methods: {
    async getupdatestamp() {
      const id = this.sortID;
      await stamp.uploadlist(id);
    },
    // 预览
    async pieView() {
      const fileID = this.sortID;
      tzService.stampDownload(fileID).then((blob) => {
        this.imageUrl = URL.createObjectURL(blob);
      });
    },
    // 下载
    async download() {
      const fileID = this.sortID;
      tzService.stampDownload(fileID).then((blob) => {
        if (blob.type === "application/json") {
          const fileReader = new FileReader();
          fileReader.onloadend = () => {
            const jsonData = JSON.parse(fileReader.result);
            // 后台信息
            this.$message({ message: jsonData.message, type: "error" });
          };
          fileReader.readAsText(blob); // 或者读取response.data
        } else {
          if ("msSaveOrOpenBlob" in navigator) {
            // 兼容ie
            window.navigator.msSaveOrOpenBlob(blob, blob + "");
          } else {
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", blob);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      });
    },
    // 获取左侧模板
    getFrameTree() {
      this.frameTree = [];
      stamp.getElectronic(this.enterpriseId).then(({ data }) => {
        this.frameTree = data || [];
        if (this.frameTree.length > 0) {
          this.currentOrgChangeHandler(this.frameTree[0]);
          this.$nextTick(() => {
            this.$refs.depTree.setCurrentKey(this.frameTree[0].sortID); // 一定要加这个选中了否则样式没有出来
            this.sortID = this.frameTree[0].sortID;
          });
        }
        this.sortID = undefined;
        this.pID = undefined;
      });
    },
    // 选中左侧模板
    currentOrgChangeHandler(val) {
      this.sortID = val.sortID;
      this.pieView();
    }
  }
};
</script>
<style lang="scss" scoped>
$top-button-height: 42px;
$middle-height: 30px;
$left-width: 600px;
.bottom_tree_table {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  .bottom_left {
    position: absolute;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    width: $left-width;
    padding-left: 12px;
    border-right: 1px solid #ebefff;
    .left_button {
      height: $top-button-height;
      padding: 10px;
    }
    .left_tree {
      overflow: auto;
      position: absolute;
      left: 5px;
      top: $top-button-height + 15px;
      bottom: 0;
      right: 0;
      .tree_1 {
        font-size: 14px;
      }
    }
  }
  .bottom_right {
    margin-left: $left-width + 20px;
    height: 100%;
    .right_button {
      height: $top-button-height;
      padding: 10px;
    }
    img {
      border: 0;
      width: 400px;
    }
  }
}

/deep/.el-tree-node__content {
  height: 31px;
  line-height: 31px;
}
/deep/.el-divider--horizontal {
  margin: 10px 0;
}
</style>
